import React from 'react';

export const FileX = React.memo(() => (
  <>
    <defs>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='linear-gradient'
        x1='6.65'
        x2='27.27'
        y1='6.65'
        y2='27.27'
      >
        <stop offset='0' stopColor='#f9dcc4'></stop>
        <stop offset='0.32' stopColor='#f8d9c0'></stop>
        <stop offset='0.64' stopColor='#f4cfb3'></stop>
        <stop offset='0.98' stopColor='#eebf9f'></stop>
        <stop offset='1' stopColor='#edbe9d'></stop>
      </linearGradient>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='linear-gradient-2'
        x1='6'
        x2='12'
        y1='5'
        y2='5'
      >
        <stop offset='0' stopColor='#f9dcc4'></stop>
        <stop offset='1' stopColor='#edbe9d'></stop>
      </linearGradient>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='linear-gradient-3'
        x1='11.76'
        x2='20.24'
        y1='11.76'
        y2='20.24'
      >
        <stop offset='0' stopColor='#68d8d6'></stop>
        <stop offset='1' stopColor='#18c9bc'></stop>
      </linearGradient>
    </defs>
    <path
      fill='url(#linear-gradient)'
      d='M23.5,2h-12a.47.47,0,0,0-.35.15l-5,5A.47.47,0,0,0,6,7.5v20A2.5,2.5,0,0,0,8.5,30h15A2.5,2.5,0,0,0,26,27.5V4.5A2.5,2.5,0,0,0,23.5,2Z'
    ></path>
    <path
      fill='url(#linear-gradient-2)'
      d='M11.69,2a.47.47,0,0,0-.54.11l-5,5A.47.47,0,0,0,6,7.69.5.5,0,0,0,6.5,8h3A2.5,2.5,0,0,0,12,5.5v-3A.5.5,0,0,0,11.69,2Z'
    ></path>
    <circle fill='url(#linear-gradient-3)' cx='16' cy='16' r='6'></circle>
    <path
      fill={'#577590'}
      d='M15.29,16L13.45,14.15L14.15,13.45L16,15.29L17.85,13.45L18.55,14.15L16.71,16L18.55,17.85L17.85,18.55L16,16.71L14.15,18.55L13.45,17.85Z'
    />
  </>
));
